import { jsx as _jsx } from "react/jsx-runtime";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
export default function CampaignLoading() {
    return (_jsx(Grid, Object.assign({ container: true, spacing: 4, direction: "row" }, { children: _jsx(Grid, Object.assign({ item: true, xs: 12, sm: 6, md: 4, xl: 3 }, { children: _jsx(Skeleton, { animation: "wave", variant: "rectangular", height: 187 }) })) })));
}
